import { render, staticRenderFns } from "./TrainerGroups.vue?vue&type=template&id=4a81cb00&scoped=true&"
import script from "./TrainerGroups.vue?vue&type=script&lang=js&"
export * from "./TrainerGroups.vue?vue&type=script&lang=js&"
import style0 from "./TrainerGroups.vue?vue&type=style&index=0&id=4a81cb00&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a81cb00",
  null
  
)

export default component.exports